export default "__VITE_ASSET__ZNVnOW9n__"